module.exports = __webpack_public_path__ + "img/logo.5df5afc4.svg";